import { Checkbox, Form } from 'antd';

import { Card } from '../../components';
import { EMPLOYEE_PAGES } from '../../navigation';
import { useI18n } from '../../i18n';

export const ALL_EMPLOYEE_PAGE_KEYS = EMPLOYEE_PAGES.map(item => item.key);

export const PagesCard = () => {
  const { t } = useI18n();

  return (
    <Card title={t('users.pages')} subtitle={t('users.pagesHint')} style={{ marginTop: 16 }}>
      <Form.Item
        name='pages'
        rules={[{ required: true, type: 'array', min: 1, message: t('users.pagesRequired') }]}
        style={{ marginBottom: 0 }}
      >
        <Checkbox.Group style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
          {EMPLOYEE_PAGES.map(item => {
            const Icon = item.icon;
            return (
              <Checkbox key={item.key} value={item.key}>
                <span style={{ display: 'inline-flex', alignItems: 'center', gap: 8 }}>
                  <Icon size={15} strokeWidth={1.75} />
                  {t(`nav.${item.key}`)}
                </span>
              </Checkbox>
            );
          })}
        </Checkbox.Group>
      </Form.Item>
    </Card>
  );
};
